import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [NzButtonModule, NzIconModule, TranslateModule, NgClass],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {
  @Input() public type: 'info' | 'warning' | 'danger' = 'info';
  @Input() public localizableText: string = '';
  @Input() closable: boolean = true;
  @Input() showIcon: boolean = true;
  @Output() closed = new EventEmitter<void>();

  public get isInfo(): boolean {
    return this.type === 'info';
  }
  public get isWarning(): boolean {
    return this.type === 'warning';
  }
  public get isDanger(): boolean {
    return this.type === 'danger';
  }

  public onCloseClick(): void {
    this.closed.emit();
  }
}
